import { useTranslation } from 'react-i18next';
import {
  OuterSection,
  OuterSectionHeading,
  OuterSectionParagraph,
  TitleRow,
} from '../StyledComponents';
import { useGetTotalUsers } from '../../data';
import CreateUserForm from './CreateUsersForm.jsx';

export const AddUsers = () => {
  const { data } = useGetTotalUsers();
  const { t } = useTranslation('users');

  return (
    <OuterSection>
      <TitleRow>
        <OuterSectionHeading>{t('addUsers.heading')}</OuterSectionHeading>
        {data.totalUsers && (
          <OuterSectionParagraph>
            {data.totalUsers} {t('addUsers.totalUsers')}
          </OuterSectionParagraph>
        )}
      </TitleRow>
      <CreateUserForm />
    </OuterSection>
  );
};
